import systemRoutes from '../system/routes';
import dealRoutes from './modules/deals';
import hotelRoutes from './modules/hotels';
import cityCountryRoutes from './modules/cities&countries';
import pageRoutes from './modules/pages';
import enquiryRoutes from './modules/enquiries';
import newsletterRoutes from './modules/newsletter';
import referrerRoutes from './modules/referrers';
import bookingRoutes from './modules/bookings';
import blogRoutes from './modules/blog';
import dealTypeRoutes from './modules/dealTypes';
import seoRoutes from './modules/seo';
import errorRoutes from './modules/errors';
import paymentRoutes from './modules/payments';
import dashboard from '../containers/dashboard';
import activityCategories from './modules/activityCategories';

const routes = [
  ...systemRoutes,
  ...seoRoutes,
  ...dealRoutes,
  ...hotelRoutes,
  ...cityCountryRoutes,
  ...pageRoutes,
  ...enquiryRoutes,
  ...newsletterRoutes,
  ...referrerRoutes,
  ...bookingRoutes,
  ...blogRoutes,
  ...dealTypeRoutes,
  ...paymentRoutes,
  ...activityCategories,

  {
    path: '/dashboard',
    exact: true,
    auth: true,
    component: dashboard,
  },
  ...errorRoutes,
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.jsx